import { useAtomValue, useSetAtom } from "jotai";
import { modelDataAtom } from "../../atoms";
import _ from "lodash";
import apiAgent from "../../api/apiAgent";
import { tMsg } from "../ToastNotifications";
import { publishGroups } from "./publishConfig";
import { updatePublishTimes } from "./utils";
import { Dispatch, SetStateAction } from "react";
import { screenTypesArray } from "../../utils/slideTemplateAllocation";

/**
 * Get and publish the models
 * @param models string of models to publish
 * @returns
 */
const useSlidesPublisher = (
  setPublishing: Dispatch<SetStateAction<boolean>>
) => {
  // Step 1: get model data from locally stored data atom
  // const modelData = useAtomValue(modelDataAtom);
  const { atom } = publishGroups.slides;
  const setPublishTimes = useSetAtom(atom);

  // Return requesting function
  return async () => {
    try {
      setPublishing(true);
      const results = await apiAgent.DataType.getAll("slides");
      // console.log(results);
      const allSlides = results.data;

      const screens = screenTypesArray.map((screen) => {
        const templates = screen.data.templateArray;
        return {
          id: screen.id,
          name: screen.name,
          templates,
          slides: allSlides
            .filter((slide: any) => slide.screenType === screen.id)
            .map((slide: any) => {
              return {
                ...slide,
                donorList: slide.donorList?.map((d: string) =>
                  d.replaceAll('"', "")
                ),
                templateName: templates[slide.templateType].name,
              };
            })
            .sort((a: any, b: any) => a.sortId - b.sortId),
        };
      });

      const filepathsJson = { [`endpoints/slides.json`]: screens };

      console.log("to publish", filepathsJson);
      const response = await apiAgent.Models.publish({ filepathsJson });

      if (response.status === 200) {
        tMsg.success("Changes have been pushed");
        updatePublishTimes("slides", setPublishTimes);
      } else throw response.statusText;
    } catch (err) {
      tMsg.error("Error pushing. See Console for details.");
      console.log(err);
    } finally {
      setPublishing(false);
    }
  };
};

export { useSlidesPublisher };
